<vex-page-layout>
	<div *transloco="let t">
		<vex-page-layout-header class="pb-16 flex flex-col justify-center items-start">
			<div>
				<h1 class="title mt-0 mb-1">{{ t('sideboard.massPrint') }}</h1>
				<vex-breadcrumbs [crumbs]="breadCrumbService.crumbs"></vex-breadcrumbs>
			</div>
		</vex-page-layout-header>
		<vex-page-layout-content [class.container]="false" [class.px-gutter]="true" class="-mt-6">
			<div class="card overflow-auto -mt-16">
				<div class="bg-app-bar px-6 h-16 border-b sticky left-0 flex flex-row justify-start items-center">
					<div class="bg-card rounded-full border px-4 bg-white w-[400px] md:w-auto flex flex-row justify-start items-center">
						<mat-icon [svgIcon]="icons.get('search')" size="20px"></mat-icon>
						<!-- TODO VEX-Update Find out why .value is not working-->
						<input
							#input
							(keyup)="applyFilter($event.target['value'])"
							class="px-4 py-3 border-0 outline-none w-full bg-transparent"
							matInput
							name="searchField"
							placeholder="{{ t('commonActions.search') }}"
							type="search" />
					</div>
					<span class="w-[10px]"></span>
					<div class="flex flex-col justify-center items-between" style="align-items: center">
						<mat-label>{{ t('common.selectFilters') }}</mat-label>
						<button (click)="openFilterDialog()" mat-button name="openMassPrintFilterDialog" type="button">
							@if (filtersSet) {
								<mat-icon style="height: 1.75rem; width: 2rem" [svgIcon]="icons.get('filter')"></mat-icon>
							} @else {
								<mat-icon style="height: 1.75rem; width: 2rem" [svgIcon]="icons.get('filterOff')"></mat-icon>
							}
						</button>
					</div>
					<span class="w-[10px]"></span>
					<div class="flex flex-col justify-center items-between" style="align-items: center; margin-top: -7px">
						<mat-label>
							{{ t('massPrint.changeDisplay') }}
						</mat-label>
						<mat-slide-toggle
							(change)="switchAggregatedOrSingle($event)"
							[disabled]="dataSource === undefined"
							[checked]="true"
							class="ml-2 mr-2"
							color="primary"
							style="margin-top: 6px"></mat-slide-toggle>
					</div>
				</div>
				@if (!finishedLoading) {
					<div class="spinner-style">
						<mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
					</div>
				}
				<table @stagger [dataSource]="dataSource" class="w-full" mat-table matSort matSortActive="number" matSortDirection="asc">
					<!-- Select Column -->
					<ng-container matColumnDef="selection">
						<th *matHeaderCellDef mat-header-cell>
							<mat-checkbox
								(change)="$event ? masterToggle() : null"
								[checked]="selection.hasValue() && isAllSelected()"
								[indeterminate]="selection.hasValue() && !isAllSelected()"
								class="pr-2"></mat-checkbox>
							{{ t('realestates.selectForMassPrint') }}
						</th>
						<td *matCellDef="let row" [attr.data-label]="t('realestates.selectForMassPrint')" mat-cell>
							<mat-checkbox
								(change)="$event ? selection.toggle(row) : null"
								(click)="$event.stopPropagation()"
								[checked]="selection.isSelected(row)"></mat-checkbox>
						</td>
					</ng-container>

					<!-- Number Column -->
					<ng-container matColumnDef="number">
						<th *matHeaderCellDef mat-header-cell mat-sort-header="number">
							{{ t('realestates.number') }}
						</th>
						<td *matCellDef="let row" [attr.data-label]="t('realestates.number')" mat-cell>
							{{ row.number }}
						</td>
					</ng-container>

					<!-- Property Number Column -->
					<ng-container matColumnDef="propertyManagementNumber">
						<th *matHeaderCellDef mat-header-cell mat-sort-header="propertyManagementNumber">
							{{ t('realestates.propertyManagementNr') }}
						</th>
						<td *matCellDef="let row" [attr.data-label]="t('realestates.propertyManagementNr')" mat-cell>
							{{ row.propertyManagementNumber }}
						</td>
					</ng-container>

					<ng-container matColumnDef="propertyManagementAccountNumber">
						<th *matHeaderCellDef mat-header-cell mat-sort-header="propertyManagementAccountNumber">
							{{ t('realestates.propertyManagementAccountNr') }}
						</th>
						<td *matCellDef="let row" [attr.data-label]="t('realestates.propertyManagementAccountNr')" mat-cell>
							{{ row.propertyManagementAccountNumber }}
						</td>
					</ng-container>

					<!-- Address Column -->
					<ng-container matColumnDef="addressBeautified">
						<th *matHeaderCellDef mat-header-cell mat-sort-header="addressBeautified">
							{{ t('user.address') }}
						</th>
						<td *matCellDef="let row" [attr.data-label]="t('user.address')" mat-cell>
							<div class="grid grid-rows-2">
								<div>{{ row.addressBeautified.street }}</div>
								<div>{{ row.addressBeautified.zipCode }} {{ row.addressBeautified.city }}</div>
							</div>
						</td>
					</ng-container>

					<ng-container matColumnDef="tenantUnitCounter">
						<th *matHeaderCellDef mat-header-cell>
							{{ t('massPrint.tenantUnitCounter') }}
						</th>
						<td *matCellDef="let row" [attr.data-label]="t('massPrint.tenantUnitCounter')" mat-cell>
							<span>{{ row.tenantUnits?.length }}</span>
						</td>
					</ng-container>

					<ng-container matColumnDef="tenantUnitNumber">
						<th *matHeaderCellDef mat-header-cell>
							{{ t('massPrint.tenantUnitNumber') }}
						</th>
						<td *matCellDef="let row" [attr.data-label]="t('massPrint.tenantUnitNumber')" mat-cell>
							<span>{{ row.tenantUnitNumber }}</span>
						</td>
					</ng-container>

					<tr *matHeaderRowDef="visibleColumns" mat-header-row></tr>
					<tr *matRowDef="let row; columns: visibleColumns" @fadeInUp class="hover:bg-hover trans-ease-out cursor-pointer" mat-row></tr>

					<!-- Row shown when there is no matching data. -->
					<tr *matNoDataRow class="mat-row">
						<td class="mat-cell" colspan="4">
							<div class="ml-4">{{ t('dashboard.noDataFound') }}</div>
						</td>
					</tr>
				</table>
				<ara-paginator
					[pageSizeOptions]="pageSizeOptions"
					[showFirstLastButtons]="true"
					aria-label="Select page of massPrintData"
					class="sticky left-0"></ara-paginator>
			</div>
			<ng-container>
				<div class="flex flex-row justify-end items-center">
					<div [matTooltip]="t('massPrint.tenantUnitCounterTooltip')">{{ t('massPrint.tenantUnitCounter') }}:{{ tenantUnitCounter }}</div>
					<button (click)="printAction()" class="m-2" color="primary" mat-raised-button type="button">
						<mat-icon [svgIcon]="icons.get('print')"></mat-icon>
					</button>
				</div>
			</ng-container>
		</vex-page-layout-content>
	</div>
</vex-page-layout>
